import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon, XIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function CostSection() {
  return <section className="bg-stage starfield py-16 sm:py-20" aria-labelledby="cost-title" data-id="element-55" data-mp="4l7ys24ll3kh">
      <div className="mx-auto max-w-4xl px-4" data-id="element-56" data-mp="4iv912sllowv">
        <div className="text-center" data-id="element-57" data-mp="3vqhkhhlk6voa">
          <ScaleIcon className="mx-auto h-9 w-9 text-gold" data-id="element-58" data-mp="3vpern44oej5q" />
          <h2 id="cost-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-59" data-mp="3qthet7smfuxp">El costo de no tenerlo</h2>
          <p className="mt-3 text-mutedDark" data-id="element-60" data-mp="3mpjbsm06dzzd">Lo que realmente perdés cada ciclo lectivo sin el Megapack</p>
        </div>

        <div className="mt-10 space-y-2" data-id="element-61" data-mp="3htksvdxm9a6c">
          {costs.map(([without, loss], index) => <motion.div key={without} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.03,
          ease: [0.23, 1, 0.32, 1]
        }} className="panel-dark grid gap-2 rounded-xl border border-lineDark p-4 sm:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] sm:gap-6" data-id="element-62" data-mp="3curbvbj4f11f" data-mpi={index}>
              <p className="flex items-start gap-2 text-sm font-bold text-white" data-id="element-63" data-mp="f9x7dc9hnfqx">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-mutedDark" data-id="element-64" data-mp="k8gsjag9cni8" />
                {without}
              </p>
              <p className="text-sm leading-relaxed text-mutedDark" data-id="element-65" data-mp="17xjeguhxd2ij">{loss}</p>
            </motion.div>)}
        </div>

        <blockquote className="panel-dark mt-10 rounded-2xl border border-gold/35 p-6 text-center text-sm font-semibold leading-relaxed text-onDark sm:p-8" data-id="element-66" data-mp="1cvunx44b5b08">
          “La próxima vez que un alumno pregunte para qué sirve estudiar Astronomía, podés mostrarle que existe vida científica
          en Argentina dedicada a explorar el universo, que cada descubrimiento astronómico cambia nuestra forma de entender el
          cosmos, que la exploración espacial es una realidad actual, y que la Astronomía es la ciencia que responde las
          preguntas más profundas sobre quiénes somos y nuestro lugar en el universo. O podés seguir explicando sin ese
          contexto.”
        </blockquote>
      </div>
    </section>;
}